export default __webpack_public_path__ + "static/media/UbuntuMono-B.a4648710.ttf";